import { fitBytes, generateMessageID } from '@libs/utils/tools'
import { fakeSocket } from '@hid/fakesocket/fakesocket'
import { KKFromMatrix } from '@hid/define/define_matrix'
import { TravelPostData } from '@hid/common/types'
import { deviceManager } from '@hid/device/device_manager'
import { VirtualIrokFe87V2IMC, VirtualIrokFe87V2IMC_24g } from '@hid/define/define'
enum DataTravelType {
  Flux = 223,
  Travel = 224,
  WatchCalibratin = 225,
}
export class Mu68Handle {
  private maxNumber = 6
  private number = 0
  private isCapturing = false
  private dataCapturing: number[] = []
  private travelType: DataTravelType | undefined

  private report = async (data: TravelPostData[]) => {
    fakeSocket.onmessage({
      data: JSON.stringify({
        ID: generateMessageID(),
        Type: this.travelType,
        Data: data,
        Error: null,
      }),
    } as MessageEvent)
  }

  handle(data: number[]) {
    if (fitBytes(data, [0x5c, 0x80, 0x92])) {
      if (this.isCapturing == false) {
        this.isCapturing = true
        this.number = 0
      }
      this.travelType = data[5] == 0x06 ? DataTravelType.Flux : DataTravelType.Travel
      data = data.slice(6)
    }
    if (this.isCapturing) {
      this.number++
      this.dataCapturing.push(...data)
      if (this.number >= this.maxNumber) {
        this.end()
      }
    }
  }

  end() {
    this.isCapturing = false
    const data: TravelPostData[] = []
    for (let i = 0; i < this.dataCapturing.length; i += 2) {
      let value = this.dataCapturing[i] + this.dataCapturing[i + 1] * 0x100
      const kk = KKFromMatrix(i / 2)
      //   if (value == 3500) {
      //     console.log('MK:0x' + (i / 2).toString(16))
      //     console.log('KK:0x' + kk.toString(16).padStart(2, '0') + ':')
      //   }
      if (deviceManager.deviceID == VirtualIrokFe87V2IMC || deviceManager.deviceID == VirtualIrokFe87V2IMC_24g) {
        if (value < 0) {
          value = 0
        }
        if (value > 3550) {
          value = 3550
        }
      }
      if (value > 0) {
        data.push({ Key: kk, Value: value })
      }
    }
    this.report(data)
    this.clear()
  }

  clear() {
    this.dataCapturing = []
    this.isCapturing = false
    this.number = 0
  }
}
